import { render, staticRenderFns } from "./DebtorReport.vue?vue&type=template&id=188d6eb5&scoped=true&"
import script from "./DebtorReport.vue?vue&type=script&lang=js&"
export * from "./DebtorReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188d6eb5",
  null
  
)

export default component.exports